import { ServerMessagePayload } from '@common/api';
import { Text } from 'pixi.js';

import { ClientGlobalSystem } from './ClientBase';

/**
 * System that displays the current in-game date and time in the top-right corner.
 *
 * Toggled via the Debug Panel.
 * The text is rendered directly on the app stage (not worldContainer)
 * so it stays fixed on screen regardless of camera position.
 */
export class TimeDisplaySystem extends ClientGlobalSystem {
  private text: Text | null = null;

  run(): ServerMessagePayload[] {
    const showTime = this.clientServices.debug.state.showTimeDisplay;
    const app = this.clientServices.render.app;

    if (!app) {
      return [];
    }

    // Create text element on first show
    if (showTime && !this.text) {
      this.text = new Text({
        text: '',
        style: {
          fontFamily: 'monospace',
          fontSize: 14,
          fill: 0xffffff,
          stroke: { color: 0x000000, width: 2 },
          align: 'right',
        },
      });
      this.text.anchor.set(1, 0); // Top-right anchor
      app.stage.addChild(this.text);
    }

    // Cleanup when toggled off to prevent memory leaks
    if (!showTime && this.text) {
      app.stage.removeChild(this.text);
      this.text.destroy();
      this.text = null;
      return [];
    }

    // Update text content and position when visible
    if (this.text && showTime) {
      const gameTime = this.services.gameTime;
      this.text.text = gameTime.getFormattedDateTime();

      // Position in top-right corner with padding
      this.text.x = app.screen.width - 10;
      this.text.y = 10;
    }

    return [];
  }
}
